/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';

class Cartela extends Component {

  changeSelected = (event) => {
    const {onClick, className} = this.props;
    onClick(className);
  }

  render() {
    const {
      className,
      classNameActive,
      label,
      selected,
      src,
      srcChange,
      checkedI,
      classNameDiv
    } = this.props;
    const srcFinal = selected
      ? src
      : srcChange;
    const activeClass = selected
      ? classNameActive
      : className;
    const classNameI = selected
      ? checkedI
      : '';

    return (<div className={classNameDiv}><a href="#" className={activeClass} onClick={this.changeSelected}>
      <img src={srcFinal} alt='Cartela'/>
      <label>{label}</label>
      <i className={classNameI}></i>
    </a></div>);
  }
}

export default Cartela;
